import React from "react";
import "./Pagination.css";

const Pagination = ({ cPage, pageSize, countOrders, updateTablePage }) => {
    const totalPages = Math.ceil(countOrders / pageSize);

    return (
        <div className="card-pagination">
            <div className="pagination-info">
                Exibindo de {cPage * pageSize + 1} a {Math.min((cPage + 1) * pageSize, countOrders)} de {countOrders}
            </div>

            <div className="pagination-container">
                <ul className="pagination">
                    {/* Botão Voltar */}
                    <li className={`page-item ${cPage === 0 ? "disabled" : ""}`}>
                        <button className="page-link" onClick={() => updateTablePage(cPage - 1)} disabled={cPage === 0}>
                            &laquo;
                        </button>
                    </li>

                    {/* Página anterior */}
                    {cPage > 0 && (
                        <li className="page-item">
                            <button className="page-link" onClick={() => updateTablePage(cPage - 1)}>
                                {cPage}
                            </button>
                        </li>
                    )}

                    {/* Página atual */}
                    <li className="page-item">
                        <button className="page-link active">
                            {cPage + 1}
                        </button>
                    </li>

                    {/* Próxima página */}
                    {cPage + 1 < totalPages && (
                        <li className="page-item">
                            <button className="page-link" onClick={() => updateTablePage(cPage + 1)}>
                                {cPage + 2}
                            </button>
                        </li>
                    )}

                    {/* Botão Avançar */}
                    <li className={`page-item ${cPage + 1 === totalPages ? "disabled" : ""}`}>
                        <button
                            className="page-link"
                            onClick={() => updateTablePage(cPage + 1)}
                            disabled={cPage + 1 === totalPages}
                        >
                            &raquo;
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default Pagination;
